import { colorPalette } from '../../colorPalette';
export const useStyles = () => ({
    menuItem: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    menuItemTitle: {
        fontSize: '14px',
        fontStyle: 'normal',
        alignSelf: 'center',
        fontWeight: 600,
        color: colorPalette.gray900,
    },
    menuBorder: {
        border: `${colorPalette.gray300} solid 0.5px`,
        backgroundColor: colorPalette.white,
        borderRadius: '30px',
        marginBottom: '3%',
        padding: '10px 8px 10px 15px',
    },
    menuBorderless: {
        backgroundColor: colorPalette.white,
        borderRadius: '30px',
        marginBottom: '3%',
        padding: '10px 8px 10px 15px',
    }
});
